import { INavigationStepData } from '../models/navigationStepData'

export const getNavigationSteps = (stepTitles: string[]) => {
  return stepTitles.map<INavigationStepData>((key, index) => ({
    title: key,
    order: index + 1,
  }))
}
